import { ConsultationDexieDb } from "../db/ConsultationDexieDb";
import { ArchiveState, SessionManifest } from "./types";

export class SessionManifestRepo {
  constructor(private readonly db: ConsultationDexieDb) {}

  async get(sessionId: string): Promise<SessionManifest | undefined> {
    return this.db.manifests.get(sessionId);
  }

  async upsert(manifest: SessionManifest): Promise<void> {
    await this.db.manifests.put(manifest);
  }

  async patch(
    sessionId: string,
    patch: Partial<SessionManifest>
  ): Promise<SessionManifest | undefined> {
    const current = await this.db.manifests.get(sessionId);

    if (!current) {
      return undefined;
    }

    const next: SessionManifest = {
      ...current,
      ...patch,
      updatedAt: Date.now(),
    };

    await this.db.manifests.put(next);
    return next;
  }

  async updateArchiveState(
    sessionId: string,
    archiveState: ArchiveState,
    extraPatch: Partial<SessionManifest> = {}
  ): Promise<SessionManifest | undefined> {
    return this.patch(sessionId, {
      archiveState,
      ...extraPatch,
    });
  }
}
